
import Login from './views/login'
import ForgotPasswordInit from './views/forgot_password_init'
import ForgotPassword from './views/forgot_password'
import FAQ from './views/FAQ'
import AsyncAppStart from './views/account/asyncAppStart'
import Shop from './views/shop'
import Product from './views/product'
import Cart from './views/shop/cart'
import Checkout from './views/shop/checkout'
import Ordersuccess from './views/shop/order-success'
import MainAccount from './views/account/main'
import Orderhistory from './views/account/order-history'
import Rewardhistory from './views/account/reward-history'
import Appstore from './views/account/appstore'
import Settings from './views/account/settings'
import Terms from './views/account/terms'
import Home from './views/home'
import Rewards from './views/rewards'
import RewardsDetail from './views/rewards_detail'


let routes = [

  {
    path: '/account/terms',
    name: 'terms',
    component: Terms,
    meta: { requiresLogin: true }
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    meta: { requiresLogin: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: true,
    meta: { requiresLogin: false },
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: ForgotPassword,
    props: true,
    meta: { requiresLogin: false },
  },
  {
    path: '/forgot_password_init',
    name: 'forgot_password_init',
    component: ForgotPasswordInit,
    meta: { requiresLogin: false },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresLogin: false },
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { requiresLogin: false },
  },
  {
    path: '/appstart',//app version and sign in web
    name: 'appstart',
    redirect: { path: '/account/asyncAppStart' },
    meta: { requiresLogin: false },
  },
  {
    path: '/account/asyncAppStart',
    name:'asyncappstart',
    component: AsyncAppStart,
    meta: { requiresLogin: false },
  },
  {
    path:'/account/appstore',
    name: 'appstore',
    component: Appstore,
    meta: { requiresLogin: false },
  },
  {
    path: '/shop',
    name: 'shop',
    component: Shop,
    props: true,
    meta: { requiresLogin: true },
  },
  {
    path:'/product/sidebar/:id',
    name: 'product',
    component: Product,
    meta: { requiresLogin: true },
  },
  {
    path:'/shop/cart',
    name: 'cart',
    component: Cart,
    meta: { requiresLogin: true }
  },
  {
    path:'/shop/checkout',
    name: 'checkout',
    component: Checkout,
    meta: { requiresLogin: true }, // possible w/o login, order button is blocked
  },
  {
    path:'/shop/order-success',
    name: 'ordersuccess',
    component: Ordersuccess,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/main',
    name: 'mainaccount',
    component: MainAccount,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/order-history',
    name: 'orderhistory',
    component: Orderhistory,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/reward-history',
    name: 'rewardhistory',
    component: Rewardhistory,
    meta: { requiresLogin: true },
  },
  {
    path:'/account/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresLogin: true },
  },
  {
    path:'/rewards',
    name: 'rewards',
    component: Rewards,
    meta: { requiresLogin: true },
  },
  {
    path:'/rewards_detail',
    name: 'rewards_detail',
    component: RewardsDetail,
    props: true,
    meta: { requiresLogin: true },
  },



];

export default routes;
